import { render, staticRenderFns } from "./editSignActivity.vue?vue&type=template&id=056b78aa&scoped=true&"
import script from "./editSignActivity.vue?vue&type=script&lang=js&"
export * from "./editSignActivity.vue?vue&type=script&lang=js&"
import style0 from "./editSignActivity.vue?vue&type=style&index=0&id=056b78aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b78aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056b78aa')) {
      api.createRecord('056b78aa', component.options)
    } else {
      api.reload('056b78aa', component.options)
    }
    module.hot.accept("./editSignActivity.vue?vue&type=template&id=056b78aa&scoped=true&", function () {
      api.rerender('056b78aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/editSignActivity.vue"
export default component.exports